import { useTranslation } from 'react-i18next';

import s from './styles.module.scss';

import type { FC } from 'react';

interface RecoveredStatusProps {}

const RecoveredStatus: FC<RecoveredStatusProps> = () => {
  const { t } = useTranslation();

  return (
    <div className={s['recovered-wrapper']} data-sub-status>
      <p className={s['recovered-text']}>{t('overviewDashboard.recovered')}</p>
    </div>
  );
};
export default RecoveredStatus;
